module.exports = __webpack_public_path__ + "img/1F1E8-1F1F3.a0f5eced.svg";